import { useVideoUI } from "@platform/store";
import { VideoMeetingActiveTab } from "../../videoMeeting.types";
import { VideoMeetingSidebar } from "./VideoMeetingSidebar";
import type { Action } from "@core/features/actions";
import { useChatUnreadCount } from "@core/features/chat";
import { useFetchUserCircles } from "@core/features/circle";
import { usePlatformStore } from "@platform/store";

export type Props = {
  priorityBasedPolicy: boolean;
  sharingAttendeeId: string;
  meetingScriptAction: Action | null;
};

export function VideoMeetingSidebarContainer({
  priorityBasedPolicy,
  sharingAttendeeId,
  meetingScriptAction,
}: Props) {
  const { activeTab, scrollPositions, closeSidebar, setActiveTab, setScrollPosition } = useVideoUI();

  const unreadCount = useChatUnreadCount();
  const user = usePlatformStore((s) => s.user);
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;

  const handleClose = () => {
    closeSidebar();
  };

  const handleTabChange = (tab: VideoMeetingActiveTab) => {
    setActiveTab(tab);
  };

  const handleScrollPositionSave = (
    tab: VideoMeetingActiveTab,
    position: number
  ) => {
    setScrollPosition(tab, position);
  };

  return (
    <VideoMeetingSidebar
      activeTab={activeTab}
      scrollPositions={scrollPositions}
      priorityBasedPolicy={priorityBasedPolicy}
      sharingAttendeeId={sharingAttendeeId}
      onClose={handleClose}
      onTabChange={handleTabChange}
      onScrollPositionSave={handleScrollPositionSave}
      meetingScriptAction={meetingScriptAction}
      unreadCount={unreadCount}
      userCircles={userCircles}
    />
  );
}

export default VideoMeetingSidebarContainer;
